import { render, staticRenderFns } from "./navs.vue?vue&type=template&id=c41bc2ba&scoped=true&"
import script from "./navs.vue?vue&type=script&lang=js&"
export * from "./navs.vue?vue&type=script&lang=js&"
import style0 from "./navs.vue?vue&type=style&index=0&id=c41bc2ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.1_cache-lo_8cdfb8a30e6790701421bf10ca45d28a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c41bc2ba",
  null
  
)

export default component.exports